import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './yacht/Header';
import Footer from './yacht/Footer';
import Home from './yacht/Home';
import Fleet from './yacht/Fleet';
import Voyage from './yacht/Voyage';
import Charter from './yacht/Charter';

// Avalon — multi-page Signature template. Horizontal-scroll voyage rhythm,
// deep navy & brass palette. Distinct skeleton from Watch.
export default function YachtTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#0A1F2E]" data-testid="yacht-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid={`yacht-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'fleet' && <Fleet setPage={setPage} />}
          {page === 'voyage' && <Voyage setPage={setPage} />}
          {page === 'charter' && <Charter setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
